export default __webpack_public_path__ + "static/bg-cultura-m-94cb5510b9c18270042c7a040e602c04.png";